import { OccConfig } from '@spartacus/core';

export const pointOfServicesOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        getPointOfServices: '/stores',
      } as any,
    },
  },
};
